var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInscribedCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "-1 -1 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Cross") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Guidelines",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Date-picker",
    transform: "translate(-202.000000, -97.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u2A02",
    transform: "translate(202.000000, 97.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "currentColor",
    strokeWidth: 0.6,
    cx: 12,
    cy: 12,
    r: 11.7
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon/action/cross",
    transform: "translate(4.200000, 4.200000)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.692183,3.83018547 C12.8362028,3.68616568 12.8362028,3.45203462 12.692183,3.30801484 C12.5481632,3.16399505 12.3140321,3.16399505 12.1700124,3.30801484 L8.00009891,7.47792829 L3.83018547,3.30801484 C3.68616568,3.16399505 3.45203462,3.16399505 3.30801484,3.30801484 C3.16399505,3.45203462 3.16399505,3.68616568 3.30801484,3.83018547 L7.47792829,8.00009891 L3.30801484,12.1700124 C3.16399505,12.3140321 3.16399505,12.5481632 3.30801484,12.692183 C3.38038742,12.7645556 3.47491688,12.8 3.56947932,12.8 C3.66404176,12.8 3.75853826,12.7637972 3.83094381,12.692183 L8.00085726,8.52226954 L12.1707707,12.692183 C12.2431433,12.7645556 12.3376728,12.8 12.4322352,12.8 C12.5267976,12.8 12.6212941,12.7637972 12.6936997,12.692183 C12.8377195,12.5481632 12.8377195,12.3140321 12.6936997,12.1700124 L8.52378623,8.00009891 L12.692183,3.83018547 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInscribedCross);
export default __webpack_public_path__ + "static/media/inscribed-cross.bcf6fc644ccdd70f90a5973dbdb31998.svg";
export { ForwardRef as ReactComponent };